import styled from 'styled-components';
import { TokenName } from '@mewssystems/design-tokens';
import { getTextTokenPreset, getToken } from '@optimus-web/common';
import { Stack } from '../../../Stack';

export const TableHeaderContainer = styled.div`
    background-color: ${getToken(TokenName.BACKGROUND_INTERACTIVE_NEUTRAL_SUBTLE_DEFAULT)};
    padding: ${getToken(TokenName.SPACING_200)}px ${getToken(TokenName.SPACING_0)};
`;

export const Title = styled.div<{ hasSubTitle: boolean }>`
    color: ${getToken(TokenName.TEXT_STATIC_PRIMARY)};
    ${getTextTokenPreset('TITLE_S')};
    margin: ${getToken(TokenName.SPACING_0)};
    padding-right: ${({ hasSubTitle, theme }) =>
        hasSubTitle ? `${getToken(TokenName.SPACING_100)({ theme })}px` : '0'};
`;

export const SubTitle = styled.div`
    color: ${getToken(TokenName.TEXT_STATIC_SECONDARY)};
    ${getTextTokenPreset('BODY_L')};
    margin: ${getToken(TokenName.SPACING_0)};
`;

export const GlobalSearchContainer = styled(Stack)``;
